export default "__VITE_ASSET__CGBUsh4R__"